export default "__VITE_ASSET__CrWhLo5x__"